import React, { useEffect, useState, useRef } from 'react';
import LText from '../../Assets/Ltext.png';
import SText from '../../Assets/Stext.png';
import SelfImage from '../../Assets/selfImage.png';
import idea from '../../Assets/idea.png';
import design from '../../Assets/design.png';
import testing from '../../Assets/testing.png';

const HomeTwo = () => {
    const images = [{
            url: idea,
            text: "Research & Ideation",
            color: "#EF45F0"
        }, 
        {
            url: design,
            text: "Brainstorm & Design",
            color: "#FF7547"
        }, 
        {
            url: testing,
            text: "Prototype & Testing",
            color: "#476FFF"
        }
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth <= 767;
    const isTablet = windowWidth > 767 && windowWidth <= 1023;
    const isResponsive = isMobile || isTablet;

    // Ref for the component to check if it's mounted
    const componentMounted = useRef(true);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            componentMounted.current = false;
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);

        return () => clearInterval(interval);
    },[images?.length]);

    return (
        <div className={`flex ${isResponsive ? 'flex-col items-center' : 'justify-between'} ${isMobile ? 'mt-16' : isTablet ? 'mt-20' : 'mt-28'}`}>
            <div className={`${isMobile ? 'mt-4' : 'mt-8'} flex flex-col`}>
                <div className='flex flex-col'>
                    <h2 className={`font-satoshi ${isMobile ? 'text-3xl' : isTablet ? 'text-4xl' : 'text-custom-xl'} font-extra-bold`}>
                        Transform <span className='italic'> Ideas</span> into <span className='italic'> Experience</span>
                    </h2>
                    <div className={`flex flex-wrap ${isResponsive ? 'flex-col' : ''} subHeadingContainer`}>
                        <div className={`font-satoshi ${isMobile ? 'text-3xl' : isTablet ? 'text-4xl' : 'text-custom-xl'} font-extra-bold hV3_t2 ${isResponsive ? 'mb-2' : ''} ${windowWidth < 1200 && !isResponsive ? 'w-full mb-2' : ''}`}>
                            people <span className='italic'> Love</span> with
                        </div>
                        <div className={`text-slider-container ${isResponsive ? 'ml-0 mt-2' : windowWidth < 1200 ? 'ml-0 w-full' : 'ml-4'} ${windowWidth < 1200 ? 'h-auto min-h-[60px]' : ''}`}>
                            {images.map((item, index) => (
                                <div
                                    key={index}
                                    className={`text-slider-item ${windowWidth < 1200 ? 'h-auto min-h-[60px]' : ''} ${
                                        index === currentIndex
                                        ? "active"
                                        : index === (currentIndex - 1 + images.length) % images.length
                                        ? "exiting"
                                        : ""
                                    }`}
                                >
                                    <img src={item.url} alt='idea design and testing' className="mr-2" />
                                    <div style={{ color: item.color }} >{item.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <h1 className={`${isMobile ? 'mt-6 text-base' : isTablet ? 'mt-6 text-lg' : 'mt-8'} homeV3_content_subText ${isResponsive ? 'pr-4' : ''}`}>
                    Hi! I'm {" "}
                    <span>
                        N Leina Singha, UI/UX designer {" "}
                    </span>
                    based in Bengaluru
                </h1>
            </div>
            <div className={`${isResponsive ? 'mt-10 flex justify-center items-center' : 'ml-12'} homeV3_ImageSection`}>
                <div className='homeV3_ImageAbsoluteTop'>
                    <img 
                        src={LText} 
                        alt="L Tilted text" 
                        className={isMobile ? 'w-20' : isTablet ? 'w-24' : ''}
                    />
                </div>
                <div className='hV3_ImageMain flex justify-center'>
                    <img 
                        src={SelfImage} 
                        alt="Self" 
                        className={isMobile ? 'max-w-[250px]' : isTablet ? 'max-w-[300px]' : ''}
                    />
                </div>
                <div className='homeV3_ImageAbsoluteBottom'>
                    <img 
                        src={SText} 
                        alt="S Tilted text" 
                        className={isMobile ? 'w-20' : isTablet ? 'w-24' : ''}
                    />
                </div>
            </div>
        </div>
    );
};

export default HomeTwo;
